import r from "./FormControlledPassword.js";
import { t } from "i18next";
import { jsx as s } from "react/jsx-runtime";
const m = (e) => /* @__PURE__ */ s(r, {
  label: t("account_setting.password"),
  type: "password",
  rules: {
    required: !0,
    pattern: {
      value: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,})(?!.*\s).{8,}$/,
      message: t("account_setting.password_wrong_format")
    },
    minLength: {
      value: 8,
      message: t("account_setting.password_min_length")
    }
  },
  ...e
});
export {
  m as default
};
//# sourceMappingURL=PasswordTextField.js.map
